<template>
  <div id="admin-signatures-layer">
    <div class="sign-title">您的企业印章</div>
    <ul class="sign-list clearfix">

      <li v-for="signatures in sealList" :key="signatures.id">
        <div class="sign-box">
          <img class="sign-img" :src="signatures.sealData" alt="">
          <p class="sign-delete" v-show="signatures.isGenerate != '1'"
            @click="deleteSealHandle(signatures.id)">删除</p>
          <!-- <img class="new-icon" src="../../assets/images/index/new-icon.png" alt=""> -->
          <img class="new-icon2" v-if="signatures.isDefault == '1'" src="../../assets/images/index/default.png" alt="">
        </div>
        <p class="sign-tip">
          <span v-if="signatures.isGenerate == '1'">系统自动生成的印章</span>
        </p>
        <div class="sign-btns clearfix">
          <a href="javascript:;" class="set-default" @click="setDefaultHandle(signatures.id)"
            v-if="signatures.isDefault != '1'">设为默认</a>
          <a href="javascript:;" class="edit-name" @click="showResetDialogHandle(signatures.id)">修改名称</a>
          <!-- <span class="default-sign">默认签章</span> -->
        </div>
        <div class="sign-name">
          <span class="sign-name-title">签章名称</span>
          <el-tooltip class="item" effect="light" :content="signatures.sealName" placement="top">
            <span class="sign-name-text">{{signatures.sealName}}</span>
          </el-tooltip>
        </div>
      </li>

    </ul>

    <div class="mask">
      <div class="sign-title">您也可以制作印章</div>
      <div class="mask-tip">印章制作说明：您可以在空白A4纸上盖上您的要制作的印章，并拍照上传（一定要清晰的图片），我们将帮助您制作电子印章。</div>
      <a href="javascript:;" @click="showUploadSeal" class="add-sign">上传图样</a>
    </div>

    <upload-sign ref="upload"></upload-sign>
    <reset-sealname ref="reset" :sealId="sealId"></reset-sealname>
  </div>
</template>
<script>
  import UploadSign from './upload-sign'
  import resetSealname from './reset-sealname'
  import {
    mapState
  } from 'vuex'
  import {
    getCompanyAuthSealInfoApi,
    setDefaultSealApi,
    deleteSealApi
  } from '@/api/space/signatures'
  import {
    getToken
  } from '@/utils/auth'
  export default {
    data() {
      return {
        signaturesList: [],
        sealId: '',
        clickDefault: false
      }
    },
    computed: {
      sealList() {
        let sealArr = this.signaturesList
        sealArr.forEach((seal, index) => {
          if (seal.isDefault === 1) {
            var item = sealArr.splice(index, 1)
            sealArr.unshift(item[0])
          }
        })
        return sealArr
      },
      ...mapState([
        'currentSpace'
      ])
    },
    mounted() {
      this.init()
    },
    components: {
      UploadSign,
      resetSealname
    },
    methods: {
      init() {
        this.getCompanySealInfoHandle()
      },
      getCompanySealInfoHandle() {
        getCompanyAuthSealInfoApi({
          companyId: this.currentSpace.companyId
        }).then(res => {
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: 'warning'
            });
          } else {
            this.signaturesList.length = 0
            res.data.sealList.forEach(seal => {
              this.signaturesList.push({
                isGenerate: seal.isGenerate,
                certSerialNumber: seal.certSerialNumber,
                companyId: seal.companyId,
                createTime: seal.createTime,
                height: seal.height,
                id: seal.id,
                isDefault: seal.isDefault,
                modifyTime: seal.modifyTime,
                sealData: ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API)? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + seal.sealData + getToken() + '&nocache=' + new Date().getTime(),
                sealName: seal.sealName,
                sealType: seal.sealType,
                status: seal.status,
                userId: seal.userId,
                width: seal.width
              })
            });
          }
        })
      },
      deleteSealHandle(sealId) {
        this.$confirm('确定要删除吗？', '温馨提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteSealApi({
            sealId
          }).then(res => {
            if (res.code !== 200) {
              this.$message({
                showClose: true,
                message: res.message,
                type: 'warning'
              });
            } else {
              this.$message({
                showClose: true,
                message: '删除成功！',
                type: 'success'
              });

              this.$nextTick(() => {
                this.getCompanySealInfoHandle()
              })
            }
          }).catch(err => {
            console.log(err)
          })
        }).catch(() => {

        });

      },
      setDefaultHandle(sealId) {
        if (!this.clickDefault) {
          this.clickDefault = true
          setDefaultSealApi({
            sealId
          }).then(res => {
            if (res.code !== 200) {
              this.$message({
                showClose: true,
                message: res.message,
                type: 'success'
              });
              this.clickDefault = false
            } else {
              this.$message({
                showClose: true,
                message: '设置成功！',
                type: 'success'
              });

              this.$nextTick(() => {
                this.getCompanySealInfoHandle()
                this.clickDefault = false
              })
            }
          }).catch(err => {
            console.log(err)
            this.clickDefault = false
          })
        }

      },
      showUploadSeal() {
        this.$refs.upload.dialogVisible = true
      },
      showResetDialogHandle(id) {
        this.sealId = id
        this.$refs.reset.dialogVisible = true
      }
    }
  }
</script>
<style scoped>
  .sign-title {
    border-left: 2px solid #EA6462;
    height: 21px;
    line-height: 21px;
    color: #333333;
    font-size: 16px;
    text-indent: 10px;
    margin: 18px 0 0 22px;
  }

  .sign-list {
    width: 888px;
    margin: 30px auto 0;
  }

  .sign-list li {
    width: 152px;
    float: left;
    margin-right: 32px;
    height: 260px;
    margin-bottom: 40px;
  }

  .sign-list li:nth-of-type(5n) {
    margin-right: 0;
  }

  .sign-box {
    width: 152px;
    height: 152px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(240, 240, 245, 1);
    border-radius: 10px;
    position: relative;
    cursor: pointer;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .sign-img {
    display: block;
    max-width: 145px;
    max-height: 145px;
  }

  .sign-delete {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 152px;
    height: 31px;
    background: rgba(191, 191, 191, 1);
    border-radius: 0px 0px 10px 10px;
    text-align: center;
    line-height: 31px;
    font-size: 14px;
    color: #ffffff;
    display: none;
  }

  .new-icon,
  .new-icon2 {
    position: absolute;
    right: 0;
    top: 0;
    display: none;
  }

  .new-icon2 {
    display: block;
  }

  .sign-tip {
    width: 152px;
    text-align: center;
    font-size: 14px;
    color: #999999;
    margin-top: 4px;
    min-height: 16px;
  }

  .sign-btns {
    width: 152px;
    /* display: flex;
    justify-content: space-between; */
    margin-top: 10px;
    position: relative;
  }

  .sign-btns a {
    display: block;
    float: right;
    width: 72px;
    height: 38px;
    text-align: center;
    font-size: 14px;
    color: #ffffff;
    line-height: 38px;
    background: #242B39;
    border-radius: 4px;
  }

  .set-default {
    width: 152px;
    height: 38px;
    text-align: center;
    font-size: 14px;
    color: #ffffff;
    line-height: 38px;
    background: #E85052;
    border-radius: 4px;
    float: left;
  }

  /* .set-default:hover{
    background: #ed7375;
  } */

  .edit-name {
    float: left !important;
  }

  .set-auth {
    background: #242B39;
    width: 54px;
    height: 38px;
    text-align: center;
    line-height: 38px;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
  }

  .sign-name {
    width: 152px;
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    font-size: 16px;
  }

  .sign-name-title {
    color: #333333;
    line-height: 17px;
  }

  .sign-name-text {
    width: 70px;
    text-align: right;
    height: 16px;
    line-height: 16px;
    overflow: hidden;
    color: #E85052;
    display: block;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mask-tip {
    font-size: 14px;
    color: #FF1110;
    margin: 16px 0 0 22px;
  }

  .add-sign {
    display: block;
    width: 100px;
    height: 32px;
    background: rgba(215, 79, 82, 1);
    box-shadow: 0px 1px 9px 0px rgba(0, 0, 0, 0.17);
    border-radius: 4px;
    text-align: center;
    line-height: 33px;
    color: #ffffff;
    font-size: 16px;
    margin-left: 22px;
    margin-top: 38px;
    margin-bottom: 50px;
  }

  .sign-box:hover {
    box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.08);
  }

  .sign-box:hover .sign-delete {
    display: block;
  }

  .sign-box:hover .new-icon {
    display: block;
  }

  .default-sign {
    display: block;
    width: 78px;
    height: 38px;
    background: rgba(180, 56, 58, 1);
    box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    position: absolute;
    left: 0;
    top: 0;
    text-align: center;
    line-height: 38px;
    color: #FFFFFF;
    font-size: 14px;
  }
</style>